import api from 'services/api'

import type { AccessDataInterface, DataAuthRequest } from './interfaces'

export const login = async (body: DataAuthRequest): Promise<AccessDataInterface> => {
  const res = await api
    .post(`autenticacao/auth`, body)
    .then((response) => {
      if (response.data.Token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${response.data.Token.accessToken}`
      }

      return response.data
    })
    .catch((err) => {
      console.error(err)
    })

  return res as AccessDataInterface
}
